@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/screen-width-breakpoints.module.less';

.marketplace-list {
  width: 100%;
  display: grid;
  grid-gap: 10px 16px;

  @media @desktop, @widescreen, @ultrawide {
    grid-template-columns: repeat(5, 150px);
  }

  @media @tablet {
    grid-template-columns: repeat(4, auto);
  }

  @media @mobile {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
}

.marketplace-item {
  border: 1px solid @onboarding-page--step--border-color;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  padding: 8px 16px;
  align-items: center;
  height: 160px;
  gap: 4px;

  &.is-add-item {
    justify-content: center;

    &:hover {
      cursor: pointer;
    }

    .logo {
      height: 22px;
    }
  }

  .logo {
    width: 118px;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .marketplace-logo {
    min-height: 28px;
    max-height: 33px;
    max-width: 140px;
    width: 90%;
  }

  .name {
    height: 36px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    max-width: 110px;
  }

  .add-store-icon {
    width: 22px;
    height: 22px;
    color: @onboarding-page--add-store-color;
  }
}

.expand-button-wrapper {
  display: flex;
  justify-content: flex-end;

  @media @mobile {
    justify-content: center;
  }
}

.connected-pill {
  border-radius: 10px;
  background-color: @onboarding-page--marketplace--connected-pill-color;
  color: @onboarding-page--marketplace--connected-pill-text-color;
}

.refresh-icon {
  height: 16px;
  width: 25px;
  fill: @onboarding-page--refresh-icon--fill-color;
}
